import React, { ChangeEvent, useState } from "react";
import Typography from "@mui/material/Typography";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";
// import './AddItem.css'
import Cancel from "./../../../assets/icons/close.png";
import axios from "axios";
import LoadingView from "../../components/LoadingView/LoadingView.js";
import { toast } from "react-toastify";
import SweetAlertModal from "../../components/SweetAlertModal/SweetAlertModal.js";
import jwtDecode from "jwt-decode";

function AddFoodcategoryDialog(props) {
  const apiAddress = process.env.REACT_APP_SECRET;
  const [loadingModal, SetloadingModal] = React.useState(false);
  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);

  const token = jwtDecode(localStorage.getItem("gotasteadmintoken"));
  // console.log(token)

  const closeLoadingModal = () => {
    SetloadingModal(false);
  };

  const [keyword, setKeyword] = useState(
    props.editFoodCategory ? props.editFoodCategory.title : null
  );

  const handleKeyword = (event) => {
    setKeyword(event.target.value);
  };
  console.log(keyword);
  const onClickSave = () => {
    SetloadingModal(true);
    setopenConfirmaitonModal(false);
    var valid = true;
    if (!!keyword == false) {
      valid = false;
      SetloadingModal(false);
      toast.error("Keyword name is missing", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    var obj = {
      Id: "string",
      CategoryName: keyword,

      IsActive: true,
      CreatorId: token.UserId,
      CreationDate: "2023-08-21T06:38:08.240Z",
      ModifierId: "string",
      ModificationDate: "2023-08-21T06:38:08.240Z",
    };
    var url = apiAddress + "/api/FoodCategory";
    SetloadingModal(true);
    if (valid) {
      axios.post(url, obj).then((response) => {
        SetloadingModal(false);
        toast.success("successfully submitted", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        console.log(response.data);
        setKeyword(null);
        props.reloadData();
        props.onHandleKeywordDialog(false);
      });
    }
  };

  const onClickUpdate = () => {
    var valid = true;
    if (!!keyword == false) {
      valid = false;
      toast.error("Keyword name is missing", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    var obj = {
      Id: props.editFoodCategory.id,
      CategoryName: keyword,

      IsActive: true,
      CreatorId: token.UserId,
      CreationDate: "2023-08-21T06:38:08.240Z",
      ModifierId: "string",
      ModificationDate: "2023-08-21T06:38:08.240Z",
    };
    console.log(obj);
    var url = apiAddress + "/api/FoodCategory";
      SetloadingModal(true);
    if (valid) {
      axios.put(url, obj).then((response) => {
        SetloadingModal(false);
        toast.success("successfully submitted", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        props.reloadData();
        props.onHandleKeywordDialog(false);
      });
    }
  };
  const handleClose = () => {
    props.onHandleKeywordDialog(false);
  };

  return (
    <div>
      <React.Fragment>
        <Dialog
          fullWidth={true}
          maxWidth="sm"
          open={props.open}
          onClose={handleClose}
        >
          <LoadingView open={loadingModal} close={closeLoadingModal} />
          <SweetAlertModal
            headerText={"Are you sure?"}
            bodyText={"You want to save this?"}
            open={openConfirmaitonModal}
            onyes={onClickSave}
            close={() => {
              setopenConfirmaitonModal(false);
            }}
          />
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>Add Food Category</DialogTitle>
            </Grid>
            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={handleClose}>
                  <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
            <div>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "2rem" }}>
                    Category
                  </Typography>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    label="Food category"
                    value={keyword}
                    onChange={handleKeyword}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ sx: { color: "#371B17" } }}
                    defaultValue={
                      props.editFoodCategory ? props.editFoodCategory.title : ""
                    }
                  />
                </Grid>
              </Grid>

              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={8}></Grid>

                <Grid item xs={4}>
                  {props.editFoodCategory ? (
                    <Button className="AddItemButtons" onClick={onClickUpdate}>
                      Update
                    </Button>
                  ) : (
                    <Button
                      className="AddItemButtons"
                      onClick={() => {
                        setopenConfirmaitonModal(true);
                      }}
                    >
                      Save
                    </Button>
                  )}
                </Grid>
              </Grid>
            </div>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    </div>
  );
}

export default AddFoodcategoryDialog;
